import { muiStyles } from 'utils/design';

export const useStyles = muiStyles((theme) => ({
  form: {
    flexGrow: 1,
  },
  filters: {
    display: 'flex',
    alignItems: 'baseline',
    flexWrap: 'wrap',
    '& > div': {
      marginBottom: theme.spacing(1),
      marginRight: theme.spacing(1),
      maxWidth: 200,
      minWidth: 0,
    },
    '& > button': {
      marginLeft: theme.spacing(1),
    },
  },
  selectFilter: {
    width: 250,
    maxWidth: 250,
  },
}));
